import { Tags } from 'lucide-react';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';
import ElementSettingCollectionTab from '@/components/sections/builder/elements/body/collection-tab/setting';
import Collection from '@/components/sections/builder/elements/body/collection-tab/collection';
import ElementContentColectionTab from '@/components/sections/builder/elements/body/collection-tab/content';
import { CollectionTabElementDataType } from '@/components/sections/builder/elements/body/collection-tab/type';

export const defaultData: CollectionTabElementDataType = {
  name: 'Collection Tab',
  contentAlign: 'left',
  headingLabel: 'Collections',
  colorSchemeCollectionList: DEFAULT_THEME_COLOR_SCHEME,
  headingSize: 'small',
  textLabel: '',
  textStyle: 'body',
  isShowViewAll: false,
  totalCol: 4,
  totalColMobile: 1,
  size: 'small',
  rounded: 0,
  showImage: true,
  showCategory: true,
  showShadow: false,
  imageRatio: 'square',
  viewAllStyle: 'default',
  labelViewAll: 'View all',
  positionViewAll: 'bottom',
};

export const ElementPreviewIcon = Tags;

const CollectionTab = {
  type: 'collection_tab',
  group: 'body',
  defaultData,
  Element: ElementContentColectionTab,
  Setting: ElementSettingCollectionTab,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [Collection],
  childs: [Collection],
};

export default CollectionTab;
